import { connect } from 'react-redux';

import { ExtraVillages, IExtraVillagesStoreProps } from './ExtraVillages';
import { IState } from '../../store';

export const mapStateToProps = (state: IState): IExtraVillagesStoreProps => {
  const { abGroup, countrysideRoadRegions, villageData, userData } = state;

  return {
    abGroup,
    regionHasRoads: !!villageData.village.regionId && countrysideRoadRegions.includes(villageData.village.regionId),
    user: userData,
    villageData,
  };
};

export const ExtraVillagesContainer = connect<IExtraVillagesStoreProps>(mapStateToProps)(ExtraVillages);
